<template>
	<div class="c-input" :class="{'z-dis': disabled, 'z-focus': focusState}" :style="{'width': parsePixel(width), 'height': parsePixel(height), 'padding-right': word ? 0 : '8px'}">
		<div class="flex-center">
			<input v-model="valueData" ref="input" class="flex-grow" :placeholder="placeholder" :maxlength="maxlength" :disabled="disabled" :readonly="readonly"
				@focus="inputHandle"
				@input="inputHandle"
				@blur="inputHandle"
				@click="$emit('click')"
				@change="inputHandle"
			>
			<a v-if="clearButton && valueData" class="clear flex-center" @click="$emit('clear')">
				<i class="tf tf-cross"></i>
			</a>
			<span v-if="word" class="flex-center">{{word}}</span>
		</div>

		<div v-show="optionsList.length || searchEmpty" ref="option" class="c-input-options" :style="optionsStyle">
			<div v-for="(item, i) in optionsList" :key="i" class="ellipsis c-input-options-item" :title="item.name" @click="optionHandle(item)">{{item.name}}</div>
			<div v-if="searchEmpty" class="c-input-options-item" style="color: #f55;">{{searchEmpty}}</div>
		</div>
	</div>
</template>

<script>
	import fun from '@/assets/script/function.js'
	
	export default {
		props: {
			type: {
				type: String,
				default: 'text'
			},
			
			value: [Number, String],
			
			width: [Number, String],
			
			height: {
				type: [Number, String],
				default: 30
			},
			
			placeholder: String,
			
			maxlength: [Number, String],
			
			decimal: [Number, String],
			
			limit: [Number, String, Array],
			
			disabled: Boolean,
			
			readonly: Boolean,
			
			word: String,
			
			clearButton: Boolean,
			
			search: Boolean,
			
			searchWidth: String
		},
		
		data() {
			return {
				valueData: this.value !== undefined ? this.value : '',
				focusState: false,
				optionsList: [],
				optionsStyle: {},
				searchEmpty: ''
			}
		},
		
		computed: {
			minLimit() {
				if (this.limit !== undefined && typeof this.limit == 'object') {
					return parseFloat(this.limit[0]);
				}
				return '';
			},
			
			maxLimit() {
				if (this.limit !== undefined) {
					return typeof this.limit == 'object' ? parseFloat(this.limit[1]) : parseFloat(this.limit);
				}
				return '';
			}
		},
		
		watch: {
			value(val) {
				this.valueData = val !== undefined ? val : '';
			},
			
			optionsList() {
				this.$nextTick(() => {
					this.focusHandle();
				});
			}
		},
		
		mounted() {
			this.$el.addEventListener('wheel', e => {
				e.stopPropagation();
			});
		},
		
		methods: {
			inputHandle(e) {
				if (this.type == 'number') {
					// var reg = /\d+/g;
					var decimal = parseInt(this.decimal) || 0;
	
					var reg = [
						[decimal ? '[^-\\d\\.]+$' : '[^-\\d]+$', ''],  //过滤非数字、负号、点的输入
						['^(-?)0?(\\d+)$', '$1$2'],					   //过滤首位为0的输入
						['^(-?)\\.$', '$1'],						   //过滤首位为.的输入
						['\\.(\\d*)\\.+', '.$1'],					   //过滤第二个.
						['^(\\d+\\.?\\d*)-+', '$1'],				   //过滤除第一位之外的-
						['^(-\\d*\\.?\\d*)-+', '$1'],				   //过滤除第一位之外的-
						['^(-?\\d+\\.\\d{'+decimal+'}).+', '$1'],	   //过滤多余小数位
						[decimal ? '[^-\\d\\.]+$' : '[^-\\d]+$', '']	//过滤非数字、负号、点的输入
					];
					
					reg.forEach(item => {
						this.valueData = this.valueData.toString().replace(new RegExp(item[0]), item[1]);
					});
					
					if (e.type == 'blur' && this.valueData !== '') {
						this.valueData = this.valueData.toString().replace(decimal ? /[^-\d\.]+/g : /[^-\d]+/g, '');
						if (this.minLimit !== '' && this.valueData < this.minLimit) {
							this.valueData = this.minLimit;
						}
						if (this.maxLimit !== '' && this.valueData > this.maxLimit) {
							this.valueData = this.maxLimit;
						}
					}
				}
				
				if (e.type == 'input') {
					this.$emit('input', this.valueData);
					this.searchHandle();
				} else {
					if (e.type == 'change' || e.type == 'blur') {
						this.$emit('input', this.valueData.toString().trim());
					}
					setTimeout(() => {
						this.$emit(e.type, e);
					});
				}
				
				if (e.type == 'focus') {
					this.focusState = true;
					this.focusHandle();
					this.searchHandle();
				} else if (e.type == 'blur') {
					this.focusState = false;
				}
			},
			
			focus() {
				this.$refs.input.focus();
			},
			
			focusHandle() {
				if (this.search) {
					let rect = this.$el.getBoundingClientRect();
					let top = rect.top + this.$el.offsetHeight - 1;
					if (window.innerHeight - top < this.$refs.option.getBoundingClientRect().height) {
						top = rect.top - this.$refs.option.getBoundingClientRect().height + 1;
					}
					this.optionsStyle = {
						left: rect.left + 'px',
						top: top + 'px',
						width: (this.searchWidth || (this.$el.offsetWidth - 2)) + 'px'
					}
					
					setTimeout(() => {
						window.addEventListener('click', this.blurHandle);
						window.addEventListener('wheel', this.blurHandle);
					});
				}
			},
			
			blurHandle() {
				if (!this.focusState) {
					setTimeout(() => {
						this.optionsList = [];
						this.searchEmpty = '';
						window.removeEventListener('click', this.foldHandle);
						window.removeEventListener('wheel', this.foldHandle);
					}, 20);
				}
			},
			
			searchHandle: fun.debounce(function() {
				this.searchEmpty = '';
				this.optionsList = [];
				
				if (this.valueData && this.valueData.toString().trim()) {
					this.$emit('search', this.valueData.toString().trim(), list => {
						this.optionsList = list;
						this.searchEmpty = '';
					}, msg => {
						this.optionsList = [];
						this.searchEmpty = msg;
					});
				}
			}, 150, false),
			
			optionHandle(item) {
				this.$emit('option', item);
			}
		}
	};
</script>

<style lang="stylus" scoped>
	.c-input {
		box-sizing: border-box;
		display: inline-block;
		border: 1px solid #ddd;
		padding: 0 8px;
		background: #fff;
		transition: all .2s ease;
				
		&.z-focus {
			border-color: #bbb;
			
			span {
				border-color: #bbb;
			}
		}

		&.z-dis {
			background: #F5F5F5;
			
			input {
				cursor: not-allowed;
			}
		}
		
		> div {
			height: 100%;
		
			input {
				box-sizing: border-box;
				width: 100%;
				height: 100%;
				border: none;
				background: none;
			}
			
			span {
				height: 100%;
				border-left: 1px solid #ddd;
				padding: 0 8px;
				margin-left: 8px;
				font-size: 14px;
				color: #333;
				background: #FAFAFA;
				transition: all .2s ease;
			}
			
			.clear {
				height: 100%;
				padding: 0 8px;
				margin-right: -8px;
				font-size: 12px;
				color: #999;
				
				&:hover {
					theme-color('main');
				}
			}
		}
		
		&-options {
			z-index: 100;
			position: fixed;
			height: auto !important;
			max-height: 300px;
			border: 1px solid #bbb;
			overflow: auto;
			background: #fff;

			&-item {
				padding: 8px 8px;
				line-height: 20px;
				font-size: 13px;
				cursor: pointer;

				&:hover {
					theme-color(main);
				}
				
				&.z-crt {
					theme-background(main);
					color: #fff !important;
				}
				
				&-level {
					width: 15px;
					height: 28px;
					margin-right: 5px;
					text-align: right;
				}
				
				.checkbox {
					margin-right: 5px;
				}
			}
		}
	}
</style>
